import gql from 'graphql-tag';

const resendVraStatusMutation = gql`
  mutation resendVraStatus($input: ResendVraStatusMutationInput!) {
    resendVraStatus(input: $input) {
      success
      errors
    }
  }
`;

export default resendVraStatusMutation;
